import ApiController from '../controller/apicontroller.js';
export default {

  // The install method will be called with the Vue constructor as the first argument, along with possible options
  install (Vue, options) {
    // ES6 way of const job = options.job
    // const { baseuri } = options;
    // Vue.prototype.$api = new ApiController(baseuri); dvb
    const api = new ApiController();
    Vue.prototype.$api = api;
    // Add $surname instance property directly to Vue components
    Vue.prototype.$baseuri = api.BaseURI;
  }
};
